/* Display estimates only. Shopify localization and checkout retain native money. */
(() => {
  if (window.BazDisplayCurrency) return;
  const configNode = document.getElementById('BazDisplayCurrencyConfig');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const countryCurrencies = { KW: 'KWD', AE: 'AED', SA: 'SAR', QA: 'QAR', OM: 'OMR', BH: 'BHD' };
  const defaultRates = { AED: 11.981357, SAR: 12.232566, QAR: 11.878601, OMR: 1.254444, BHD: 1.229778 };
  const currency = countryCurrencies[config.country] || config.nativeCurrency;
  const enabled = config.enabled === true && config.nativeCurrency === 'KWD' && currency !== 'KWD' && currency in defaultRates;
  const configured = Number(config.rates?.[currency]);
  const rate = Number.isFinite(configured) && configured > 0 && configured <= 1000 ? configured : defaultRates[currency];
  let numberFormat;
  try { numberFormat = new Intl.NumberFormat(config.locale || 'en', { numberingSystem: 'latn', maximumFractionDigits: 0 }); }
  catch { numberFormat = new Intl.NumberFormat('en', { maximumFractionDigits: 0 }); }
  const convertedAmount = (amount, compareAmount = null, saleAmount = null) => {
    const original = Number(amount);
    if (!enabled || !Number.isFinite(original) || original < 0) return null;
    let rounded = Math.round(original / 100 * rate);
    if (compareAmount !== null && saleAmount !== null) {
      const compare = Number(compareAmount), sale = Number(saleAmount);
      if (Number.isFinite(compare) && Number.isFinite(sale) && compare >= sale && sale >= 0) {
        rounded = Math.round(compare / 100 * rate) - Math.round(sale / 100 * rate);
      }
    }
    return rounded;
  };
  const formatAmount = (...args) => {
    const rounded = convertedAmount(...args);
    return rounded === null ? null : `${numberFormat.format(rounded)} ${currency}`;
  };
  const updateMoney = node => {
    if (!(node instanceof Element) || node.dataset.bazBaseCurrency !== 'KWD') return;
    const amount = node.getAttribute('data-baz-money');
    if (amount == null || amount.trim() === '') return;
    const compare = node.getAttribute('data-baz-compare'), sale = node.getAttribute('data-baz-sale');
    const formatted = formatAmount(amount, compare, sale);
    if (formatted !== null && node.textContent !== formatted) node.textContent = formatted;
    // The native value remains KWD for payment terms; only the visual shimmer clone follows this display.
    const shimmer = formatted !== null ? node.closest('text-component') : null;
    if (shimmer && shimmer.querySelector('[data-baz-money]') === node && shimmer.getAttribute('data-baz-shimmer-value') !== formatted) {
      shimmer.setAttribute('data-baz-shimmer-value', formatted);
    }
    const badge = compare !== null && sale !== null ? node.closest('[data-b4-sale-badge]') : null;
    if (badge && formatted !== null) {
      const zeroSaving = convertedAmount(amount, compare, sale) <= 0;
      badge.hidden = zeroSaving;
      node.toggleAttribute('data-baz-zero-savings', zeroSaving);
    }
  };
  const refresh = root => {
    if (!(root instanceof Element) && root !== document) return;
    if (root instanceof Element && root.matches('[data-baz-money]')) updateMoney(root);
    root.querySelectorAll('[data-baz-money]').forEach(updateMoney);
  };
  window.BazDisplayCurrency = { refresh, formatAmount, currency, rate, enabled };
  if (!enabled) return;
  const observed = new WeakSet();
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') updateMoney(record.target);
      else for (const node of record.addedNodes) {
        if (node instanceof Element) refresh(node);
      }
    }
  });
  const observeRoot = root => {
    if (!(root instanceof Element) || observed.has(root)) return;
    observed.add(root);
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-baz-money', 'data-baz-compare', 'data-baz-sale'] });
  };
  const init = () => {
    refresh(document);
    document.querySelectorAll('#MainContent, cart-drawer-component, dialog, predictive-search').forEach(observeRoot);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('baz:money-update', event => refresh(event.target));
  document.addEventListener('shopify:section:load', event => { refresh(event.target); observeRoot(event.target); });
})();
